module.exports = __webpack_public_path__ + "media/images/pla/pla15-48c8f7f069008a1982bb59a33e259748.jpg";